module.exports = __webpack_public_path__ + "../resources/img/pictogram_pv.90e7baf6.png";